import { Auth } from "aws-amplify";
import { MESSAGES } from "../../Utils/ErrorMessages";

async function loginUser(email, password) {
	localStorage.clear();
	try {
		return await Auth.signIn(email, password);
	} catch (error) {
		alert(error.message);
		throw error;
	}
}

async function confirmLoginMfa(user, code) {
	return Auth.confirmSignIn(user, code, "SOFTWARE_TOKEN_MFA");
}

async function beginLoginMfaSetup(user) {
	return Auth.setupTOTP(user);
}

async function verifyLoginMfaSetup(user, code) {
	await Auth.verifyTotpToken(user, code);
	await Auth.setPreferredMFA(user, "TOTP");

	try {
		return await Auth.confirmSignIn(user, code, "MFA_SETUP");
	} catch (error) {
		return null;
	}
}

async function registerUser(props) {
	try {
		await Auth.signUp({
			username: props.user.username,
			attributes: {
				email: props.user.username,
				name: `${props.user.foreName} ${props.user.surname}`,
			},
			password: props.user.password,
		});

		props.history.push("/confirmRegister");
	} catch (e) {
		props.setisLoading(false);
		if (e.code === "InvalidPasswordException") {
			props.Seterrormsg({ authErr: MESSAGES.PASSWORD_RESTRICTION });
		} else if (e.code === "UsernameExistsException") {
			props.Seterrormsg({
				authErr:
					"An error is encountered while registering your account. Please contact service desk.",
			});
		} else if (e.code === "UsernameExistsException") {
			props.Seterrormsg({
				authErr:
					"An error is encountered while registering your account. Please contact service desk.",
			});
		} else {
			props.Seterrormsg({ authErr: e.message });
		}
	}
}

async function confirmUser(props) {
	try {
		await Auth.confirmSignUp(props.user.username, props.user.confirmationCode, {
			forceAliasCreation: true,
		});
		props.history.push("/dashboard");
	} catch (e) {
		if (e.code === "InvalidParameterException") {
			props.Seterrormsg({ authErr: MESSAGES.CODE_RESTRICTION });
		} else {
			props.Seterrormsg({ authErr: e.message });
		}
	}
}

async function getSessionData() {
	const user = await Auth.currentSession();
	return user;
}

const isUserLoggedIn = async () => {
	try {
		await Auth.currentAuthenticatedUser();
		return true;
	} catch (error) {
		return false;
	}
};

export {
	loginUser,
	confirmLoginMfa,
	beginLoginMfaSetup,
	verifyLoginMfaSetup,
	registerUser,
	confirmUser,
	getSessionData,
	isUserLoggedIn,
};
